import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import { PHONES } from 'styles/media-queries'

const { unit } = measures

export const filtersWrapper = css`
  ${PHONES} {
    display: flex;
    flex-direction: column;
  }
`

export const phoneSpace = css`
  ${PHONES} {
    margin-bottom: ${unit * 2}px;
  }
`
